import { toast } from 'material-react-toastify';

import { UnauthorizedError } from '../services/Api';

export const toastApiError = (err: unknown) => {
  if (err instanceof UnauthorizedError) {
    return;
  }

  toast.error(err instanceof Error ? err.message : 'Unknown API error.');
};
